const uiNextLanguages = require("../shared/assets/uiNextLanguages.json");
const { LANG_CODE_EN } = require("../shared/utils/multilang/config.json");
const packageJson = require("./package.json");

// TODO: Add new langs
const nonUiLangs = [
  "ab", "ake", "alt", "as", "av", "ba", "btk", "cze", "bum", "car", "ce", 
  "nya", "lu", "ch", "da", "prs", "eo", "cfm", "fo", "fj", "grt", "kl", "chn",
  "ha", "he", "hl", "hmr", "is", "ig", "il", "id", "ja", "kbd", "kk", "kh", "km",
  "nnb", "rw", "gil", "rn", "koo", "kpy", "ku", "ky", "lo", "lv", "lt", "loz", "lg",
  "luo", "lua", "mas", "mk", "mg", "ms", "mni", "mi", "mrh", "mfe", "lus", "mon", "cnr", "ne",
  "nb", "nyo", "om", "kj", "pam", "pag", "pa", "rar", "rue", "sm", "sat", "sh", "kar",
  "sn", "si", "sk", "som", "st", "sv", "tl", "ty", "zht", "tg", "te", "th", "tpi", "to",
  "tn", "tum", "tr", "tk", "ak", "ur", "uz", "ve", "vi", "cy", "xh", "yo", "zom", "zu",
];

module.exports = {
  i18n: {
    defaultLocale: LANG_CODE_EN,
    fallbackLng: LANG_CODE_EN,
    locales: [...(new Set([...uiNextLanguages.map((l) => l.id),...nonUiLangs]))],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + packageJson.version,
    },
  },
};
